import classNames from "classnames";
import { MouseEventHandler, ReactChild } from "react";

import Spinner from "components/Spinner";

import "./Button.css";
import { useIsLoading } from "shared/hooks/requestStatusHooks";

export type PathologyWatchButtonProps = {
  type?: "button" | "submit" | "reset";
  id?: string;
  title?: string;
  ariaLabel?: string;
  color?: "red" | "green" | "grey" | "yellow" | "blue";
  size?: "small" | "large";
  disabled?: boolean;
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  children?: ReactChild;
  testId?: string;
  form?: string;
  displaySpinner?: boolean;
  noWrap?: boolean;
  tabIndex?: number;
  apiService?: string;
};

export const PathologyWatchButton = ({
  type = "button",
  id,
  title,
  ariaLabel,
  color = "grey",
  size,
  disabled,
  className = "",
  onClick,
  children,
  testId,
  form,
  displaySpinner,
  noWrap,
  tabIndex,
  apiService,
}: PathologyWatchButtonProps) => {
  const loading = useIsLoading(apiService || "") || false;
  return (
    <button
      type={type}
      id={id}
      title={title}
      aria-label={ariaLabel}
      className={classNames(
        "pwButton",
        `pwButton--${color}`,
        size ? `pwButton--${size}` : "",
        displaySpinner ? "pwButton__spinnerContainer" : "",
        noWrap ? "pwButton--noWrap" : "",
        className
      )}
      onClick={onClick}
      disabled={disabled || loading}
      data-testid={testId}
      tabIndex={tabIndex}
      form={form}
    >
      {displaySpinner && <Spinner size="1em" />}
      {children}
    </button>
  );
};

export const BorderlessButton = ({
  title,
  id,
  type,
  size,
  ariaLabel,
  onClick,
  testId,
  disabled,
  children,
  className = "",
}: Partial<PathologyWatchButtonProps>) => (
  <PathologyWatchButton
    type={type}
    id={id}
    title={title}
    size={size}
    testId={testId}
    onClick={onClick}
    disabled={disabled}
    ariaLabel={ariaLabel}
    className={`pwButton--borderless ${className}`}
  >
    {children}
  </PathologyWatchButton>
);
